import React, { useState } from 'react'
import TableOfContents from './TOC'
import './ExtendedInfoAccordion.css'
import usePersonData from './usePersonData'
import LoadingSpinner from '../../Movie/Loading'
import SearchPerson from './SerchPerson'
import AccordiansUi from './AccordiansUi'
// import { button } from 'aws-amplify'

// Function to handle clicking on sections and scrolling to them
const handleSectionClick = ({ sectionId, activeSection, setActiveSection, mode }) => {
  if (sectionId === activeSection) {
    setActiveSection('')
  } else {
    setActiveSection(mode === 'edit' ? sectionId : 'section1')
  }

  setTimeout(() => {
    // Scroll to the corresponding section by adjusting the scroll behavior
    const sectionElement = document.getElementById(mode === 'edit' ? sectionId : 'section1')
    if (sectionElement) {
      // Calculate the offset for scrolling to the beginning of the section
      const offset = sectionElement.getBoundingClientRect().top + window.scrollY

      // Scroll smoothly to the beginning of the section
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    }
  }, 500)
}

function ExtendedInfoAccordians() {
  // State for tracking active section
  const [activeSection, setActiveSection] = useState('section1')

  // Custom hook to manage person data and state
  const {
    PersoninputData,
    personName,
    personNamete,
    shortBio,
    shortBiote,
    wikipediaURL,
    error,
    personData,
    personalAndBackGroundInfo,
    personFavorites,
    personDataCareers,
    personalAssetsAndSocialMedia,
    rumorsAndControversies,
    businessVentures,
    politicsInfo,
    familyAndRelationships,
    valueChanged,
    achievementsAndHonors,
    loader,
    mode,
    reviews,
    setPersonName,
    setPersonNamete,
    setShortBio,
    setShortBiote,
    setWikipediaURL,
    setInputData,
    setFamilyAndRelationships,
    sendValueChangedBoolean,
    fetchPersonData,
    setPersonalAndBackGroundInfo,
    setPersonFavorites,
    setPersonDataCareers,
    setPersonalAssetsAndSocialMedia,
    setRumorsAndControversies,
    setBusinessVentures,
    setPoliticsInfo,
    setAchievementsAndHonors,
    setLoader,
    setReviews,
  } = usePersonData()

  return (
    <>
      {loader && <LoadingSpinner />}
      {!(personData && personData.PK) && mode === 'edit' && (
        <SearchPerson fetchPersonData={fetchPersonData} />
      )}
      {mode === 'create' && (
        <div style={{ marginTop: '5px' }}>
          {/* Row containing Table of Contents and main content */}
          <div className='row' style={{ width: '130%' }}>
            {/* Table of Contents */}
            <div className='col-md-3'>
              <TableOfContents
                activeSection={activeSection}
                handleSectionClick={sectionId =>
                  handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
                }
              />
            </div>
            {/* Main content */}
            <div className='col-md-9'>
              <AccordiansUi
                activeSection={activeSection}
                handleSectionClick={handleSectionClick}
                setActiveSection={setActiveSection}
                PersoninputData={PersoninputData}
                personName={personName}
                personNamete={personNamete}
                error={error}
                setInputData={setInputData}
                sendValueChangedBoolean={sendValueChangedBoolean}
                shortBio={shortBio}
                shortBiote={shortBiote}
                setShortBiote={setShortBiote}
                setShortBio={setShortBio}
                setPersonName={setPersonName}
                setPersonNamete={setPersonNamete}
                setWikipediaURL={setWikipediaURL}
                valueChanged={valueChanged}
                fetchPersonData={fetchPersonData}
                personData={personData}
                setLoader={setLoader}
                wikipediaURL={wikipediaURL}
                personalAndBackGroundInfo={personalAndBackGroundInfo}
                setPersonalAndBackGroundInfo={setPersonalAndBackGroundInfo}
                setFamilyAndRelationships={setFamilyAndRelationships}
                familyAndRelationships={familyAndRelationships}
                setPersonFavorites={setPersonFavorites}
                personFavorites={personFavorites}
                setPersonDataCareers={setPersonDataCareers}
                personDataCareers={personDataCareers}
                setPersonalAssetsAndSocialMedia={setPersonalAssetsAndSocialMedia}
                personalAssetsAndSocialMedia={personalAssetsAndSocialMedia}
                achievementsAndHonors={achievementsAndHonors}
                setAchievementsAndHonors={setAchievementsAndHonors}
                setBusinessVentures={setBusinessVentures}
                setRumorsAndControversies={setRumorsAndControversies}
                rumorsAndControversies={rumorsAndControversies}
                businessVentures={businessVentures}
                setPoliticsInfo={setPoliticsInfo}
                politicsInfo={politicsInfo}
                mode={mode}
                reviews={reviews}
                setReviews={setReviews}
              />
            </div>
          </div>
        </div>
      )}
      {personData && personData.PK && mode === 'edit' && (
        <div style={{ marginTop: '5px' }}>
          <button type='button' className='btn btn-primary' onClick={() => setActiveSection('all')}>
            Open All Accordians
          </button>
        </div>
      )}
      {personData && personData.PK && mode === 'edit' && (
        <div style={{ marginTop: '5px' }}>
          {/* Row containing Table of Contents and main content */}
          <div className='row' style={{ width: '130%' }}>
            {/* Table of Contents */}
            <div className='col-md-3'>
              <TableOfContents
                activeSection={activeSection}
                handleSectionClick={sectionId =>
                  handleSectionClick({ sectionId, activeSection, setActiveSection, mode })
                }
              />
            </div>
            {/* Main content */}
            <div className='col-md-9'>
              <AccordiansUi
                activeSection={activeSection}
                handleSectionClick={handleSectionClick}
                setActiveSection={setActiveSection}
                PersoninputData={PersoninputData}
                personName={personName}
                personNamete={personNamete}
                error={error}
                setInputData={setInputData}
                sendValueChangedBoolean={sendValueChangedBoolean}
                shortBio={shortBio}
                shortBiote={shortBiote}
                setShortBiote={setShortBiote}
                setShortBio={setShortBio}
                setPersonName={setPersonName}
                setPersonNamete={setPersonNamete}
                setWikipediaURL={setWikipediaURL}
                valueChanged={valueChanged}
                fetchPersonData={fetchPersonData}
                personData={personData}
                setLoader={setLoader}
                wikipediaURL={wikipediaURL}
                personalAndBackGroundInfo={personalAndBackGroundInfo}
                setPersonalAndBackGroundInfo={setPersonalAndBackGroundInfo}
                setFamilyAndRelationships={setFamilyAndRelationships}
                familyAndRelationships={familyAndRelationships}
                setPersonFavorites={setPersonFavorites}
                personFavorites={personFavorites}
                setPersonDataCareers={setPersonDataCareers}
                personDataCareers={personDataCareers}
                setPersonalAssetsAndSocialMedia={setPersonalAssetsAndSocialMedia}
                personalAssetsAndSocialMedia={personalAssetsAndSocialMedia}
                achievementsAndHonors={achievementsAndHonors}
                setAchievementsAndHonors={setAchievementsAndHonors}
                setBusinessVentures={setBusinessVentures}
                setRumorsAndControversies={setRumorsAndControversies}
                rumorsAndControversies={rumorsAndControversies}
                businessVentures={businessVentures}
                setPoliticsInfo={setPoliticsInfo}
                politicsInfo={politicsInfo}
                mode={mode}
                reviews={reviews}
                setReviews={setReviews}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ExtendedInfoAccordians
